import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 24px 16px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
  gap: 32px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    padding: 24px 48px;
  }
`;

export const TitleWrapper = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 30px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.5px;
`;

export const TagTitle = styled.h3`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-self: stretch;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black9};
  text-overflow: ellipsis;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;

  margin: 0 0 16px 0;
`;

export const TagSection = styled.div`
  &:not(:last-child) {
    margin-bottom: 32px;
  }
`;

export const SubscriptionCardsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  gap: 16px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
